import AppController from "./controller/app-controller";

document.addEventListener("DOMContentLoaded", function () {
	const app = new AppController();
});
